import type { FaireProductEntity } from "../../entity_types/product";

export const p_nb2e63pmmx: FaireProductEntity = {
  token: "p_nb2e63pmmx",
  type: "product",
  name: "Vintage Gold Oval Dial Bracelet Quartz Watch DP25F730",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/d50f10efe9fc7547c9fd65ede8a342ddc501c77f4ec860b501f6ce44af9aca0c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/684adb6aa8ea87dd4e58ac1ab2fc58d4e9d67dba73e56d20bdd347f95348227a.jpeg",
    "https://cdn.faire.com/fastly/d3dbe9f59343ca2a918d739f219d83cee6d0d9f7afd88cf7f8689e31ec92fe2a.jpeg",
    "https://cdn.faire.com/fastly/b25364c30251370c9c1de803f07f7716143ca8f3261cd16a1f9b726c85461102.jpeg",
    "https://cdn.faire.com/fastly/e395819b8cf958256a7c56c95253a0b4bc8af02edca81782c5b46fa15f6493f1.jpeg",
    "https://cdn.faire.com/fastly/b65bbc98cffa625cc301d86be44ee967bd05344d470b479eb05fb549d0ae506d.jpeg",
    "https://cdn.faire.com/fastly/81eba88e6276178d762dc369faa8b08d1029d6562f98c3fb64d2c426aae81608.jpeg",
    "https://cdn.faire.com/fastly/09de014808987bbb454add0cdbbb4ed898a79c8c7b9aacc6f6dbe055e6ea3390.jpeg",
  ],
  priceDollars: 19.25,
  description:
    "Feature:\n * Vintage, Chic\n * Oval Dial\n * Gold Tone \n * Precise Quartz Movement\n * Standard Glass Crystal\n * No Water Resistant\n * Bracelet Link Design\n * Comfortable & Adjustable Strap \n * Durable Case\n * Perfect Gift\n * Daily Fitting\n * Casual Style\n\n Material:\n * Metal\n\n Weigh: * 50g\n\n Package:\n * Package include 1 watch.\n\n * Avoid strong impacts or drops to prevent damage to the movement or glass. For leather straps: avoid direct contact with water, perfume to prevent discoloration or hardening.\n * Water resistance is limited. Do not wear the watch while swimming, showering, or exposing it to hot water.\n * Color may slightly vary due to lighting and monitor differences. Store the watch in a cool, dry place when not in use.\n * Product includes watch only (no extra jewelry/props included). ",
  tags: [],
  msrpDollars: 38.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:13.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
